import React, { useState, useEffect } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import AlertBar from '../AlertBar';
import LandingNavbar from './LandingNavbar';
import LandingMain from "./LandingMain";
import LandingFooter from "./LandingFooter";
import LandingPricing from "./LandingPricing";
import LandingLogin from "./LandingLogin";
import LandingRegister from "./LandingRegister";
import LandingResetPassword from "./LandingResetPassword";
import LandingNewPassword from './LandingNewPassword';
import LandingPasswordSaved from './LandingPasswordSaved';
import Terms from './Terms';
import FAQ from "./FAQ";
import "../../styles/LandingPage.css";
import LandingMobileNavbar from './LandingMobileNavbar';

export default function LandingPage({ handleLogin, loggedIn }) {
    const location = useLocation();
    const [mobileActive, setMobileActive] = useState(false);
    const handleMobileActive = (e) => {
        setMobileActive(!mobileActive);
    }

    useEffect(() => {
        if (location.state && location.state.goToFeatures) {
            document.querySelector("#features").scrollIntoView({ behavior: 'smooth'});
        }
    }, [location]);
    
    return (
        <div className="LandingPage">
            <LandingMobileNavbar
            mobileActive={mobileActive} 
            loggedIn={loggedIn}
            handleMobileClose={handleMobileActive} />
            {location.pathname === '/' && 
                <AlertBar alertHTML={
                    `Want to see Salewave in action? <a href="#">Watch our demo video</a> <span role="img" aria-label="eyes">👀</span>`
                }/>        
            }

            <LandingNavbar 
            loggedIn={loggedIn}
            handleMobileActive={handleMobileActive} />
                <Switch>
                    <Route path={'/'} exact component={LandingMain} />
                    <Route path={'/login'} render={(props) => {
                        return <LandingLogin {...props} handleLogin={handleLogin} />
                    }} />
                    <Route path={'/register'} component={LandingRegister} />
                    <Route path={'/terms'} component={Terms} />
                    <Route path={'/faq'} component={FAQ} />
                    <Route path={'/pricing'} component={LandingPricing}/>
                    <Route path={'/resetpassword'} component={LandingResetPassword} />
                    <Route path={'/newpassword'} component={LandingNewPassword} />
                    <Route path={'/passwordsaved'} component={LandingPasswordSaved} />
                </Switch>
            <LandingFooter />
        </div>
    )
}